<template>
    <div class="box-layout childs-details">
        <form>
            <div class="form" v-if="participant && lookups['gender_id'] && lookups['tshirt_size_id'] && lookups['swimming_ability_id']">

                <transition-group name="slide-fade">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" key="error" v-if="errors.errors.length > 0">
                        <div class="box-layout-inner alerts-banner">
                            <div class="full-width dark-red">
                                <div class="price-subtotal">
                                    <span class="text-center">{{ locale.form.text_error }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" key="info" v-if="$route.query.notify">
                        <div class="box-layout-inner">
                            <a class="acc-alerts urgent">
                                <i class="fa fa-child"></i>
                                <span class="title" v-html="locale.form.text_notify_alert"></span>

                                <i class="fa fa-chevron-right"></i>
                            </a>
                        </div>
                    </div>
                </transition-group>

                <div class="form-layout">
                    <span>
                        <div id="important_information" data-field="important_information">
                            <label>
                                <span style="color: red;">Important Information</span>
                                <br>Please note this information will be shared with the Camp Manager of your child/ren’s camp
                            </label>
                        </div>
                    </span>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="box-layout-inner">
                        <transition-group name="list">
                            <div class="steps" v-for="(fields, step) in formData" :id="'step-'+(step+1)" :key="'step-'+(step+1)" v-if="required_fields[fields[0].name].indexOf('required') > -1 || required_fields[fields[0].name].indexOf('validschool') > -1 || show_non_required">
                                <form-field key="fields.top" :data="fields" :step="step" :lookups="lookups" :dateofbirth="dateofbirth" :dob="dob" :participant="participant" :required_fields="required_fields"></form-field>
                            </div>
                            <div class="steps" key="form-expand" v-show="!show_non_required && formData.length > 0">
                                <div class="form-layout">
                                    <div class="row more-details">
                                        <span v-html="locale.form.text_expanded_form_description"></span>
                                        <a @click="show_non_required = true" class="expand cta-button blue" v-html="locale.form.button_expanded_form_text"></a>
                                    </div>
                                </div>
                            </div>
                            <div class="steps" v-for="(fields, step) in formDataBottom" :id="'step-'+(step+1)" :key="'step-'+(step+1)" v-if="required_fields[fields[0].name].indexOf('required') > -1 || show_non_required">
                                <form-field key="fields.top" :data="fields" :step="step" :participant="participant" :formData="formData" :required_fields="required_fields"></form-field>
                            </div>
                            <div class="steps" key="form-continue" v-if="formData.length > 0">
                                <div class="form-layout">
                                    <div class="row">
                                        <a class="continue cta-button red" @click="progress(participant.id)">{{ ($route.params.hasOwnProperty('id') ? ($route.query.hasOwnProperty('notify') ? 'Update and confirm child details' : 'Update child details') : 'Confirm child details') }}</a>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
                <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
            </div>
        </form>
    </div>
</template>

<script>
    import non_uk_schools from '../../../../assets/data/schools.json';
    export default {
        props: ['participantId'],
        components: {
            'form-field': require('./ParticipantField.vue')
        },
        data () {
            return {
                // show_non_required: this.$route.name == 'account.children.update',
                show_non_required: true,

                participant: undefined,
                required_fields: [],
                loading: false,

                //Form data
                consentCheck: [],
                dob: {
                    date: "",
                    month: "",
                    year: "",
                },
                formData: [],
                formDataBottom: [],
                //Lookup
                lookups: { gender_id: [], swimming_ability_id: [], tshirt_size_id: [] },
                schools: [],
                school_datalist: non_uk_schools
            }
        },

        methods: {
            progress: function (participantId) {
                //console.log('Progress Start');

                /**
                 * Obviously don't want to continue if there are errors.
                 */
                var check = true;
                this.$children.forEach(vm => {
                    vm.$children.forEach(vm => {
                        vm.$validator.validateAll().then(response => {
                            if(!response) {
                                check = false;
                                if ($(".form-layout:has(.has-error)").length) {
                                  $("html, body").stop(true, false).animate({scrollTop: $(".form-layout:has(.has-error)").offset().top}, "slow");
                                }
                            }
                        }).catch( error => {
                            check = false;
                        });
                    });
                });

                setTimeout(() => {
                    if(!check) {
                        this.loading = false;
                        return false;
                    }

                    /** Setting has_given_consent to 1 if set as true **/
                    if(this.participant.has_given_consent === true || this.participant.has_given_consent === 1)
                        this.participant.has_given_consent = 1;
                    else
                        this.participant.has_given_consent = 0;
                    /** Setting has_anaphylaxsis_agreement to 1 if set as true **/
                    if(this.participant.has_anaphylaxsis_agreement === true || this.participant.has_anaphylaxsis_agreement === 1)
                        this.participant.has_anaphylaxsis_agreement = 1;
                    else
                        this.participant.has_anaphylaxsis_agreement = 0;
                    /** Setting has_treatment_permission to 1 if set as true **/
                    if(this.participant.has_treatment_permission === 2 || this.participant.has_treatment_permission === 1)
                        this.participant.has_treatment_permission = 1;
                    else
                        this.participant.has_treatment_permission = 0;

                    this.participant.dob = this.dateofbirth;

                    if (typeof $(".title-bar").offset() !== 'undefined') {
                      $("html, body").animate({scrollTop: $(".title-bar").offset().top}, "slow");
                    }

                    var participant = this.participant;

                    //Deleting the appriate items in the participant object that won't be accepted through the api call
                    delete participant.id;
                    delete participant.user_id;

                    axios.patch('/camp-booking/participants/'+(this.$route.params.hasOwnProperty('id') ? this.$route.params.id : this.participantId), participant)
                        .then(response => {
                            if(response.data.status == "success" && response.data.data.updated && !this.$route.params.hasOwnProperty('id')) {
                                this.$emit('confirmed', (this.$route.params.hasOwnProperty('id') ? this.$route.params.id : this.participantId));
                            }
                            if(response.data.status == "success" && response.data.data.updated && this.$route.params.hasOwnProperty('id')) {
                                this.$root.alert('Child updated!', 'success');
                                this.$router.push({ name: 'account.children'});
                            }
                        })

                }, 1500)
            },
            getRequiredFields: _.debounce(
                function () {
                    if((this.$route.params.hasOwnProperty('id') ? this.$route.params.id : this.participantId))
                        axios.get('/camp-booking/participants/'+(this.$route.params.hasOwnProperty('id') ? this.$route.params.id : this.participantId)+'/required-fields')
                            .then(response => {
                                var required_fields = [];
                                var participant = this.participant;
                                $.map(response.data.data, function(value, index) {
                                    required_fields[index] = [];
                                    if(value === true) {
                                        required_fields[index].push('required');
                                        //Placing a max length of 1024 for camp notes
                                        if(['camp_notes'].indexOf(index) > -1) {
                                            required_fields[index].push('max:1024');
                                        }
                                        //Placing a max length of 255 for text areas and 45 for regular inputs
                                        else if(['emergency_contact', 'doctor_details'].indexOf(index) > -1) {
                                            required_fields[index].push('max:255');
                                        } else {
                                            required_fields[index].push('max:45');
                                        }
                                    } else if(value instanceof Object) {
                                        if(participant && participant[value.dependent_field]) {
                                            required_fields[index].push('required');
                                        }
                                        required_fields[index].push('max:255');
                                    } else {
                                        if(value.toString() == 'required-group-school') {
                                            if(!participant.school_id && !participant.non_uk_school_name) {
                                                required_fields[index].push('required');
                                            }
                                            //Don't need to set a maximum length to the school name as only the id is sent to the api
                                            if(index == 'non_uk_school_name') {
                                                required_fields[index].push('max:45');
                                            }
                                            required_fields[index].push('validschool');
                                        }

                                    }

                                    if(index == 'dob')
                                        required_fields[index].push('dateofbirth');
                                });

                                if(this.formData.length == 0 && this.formDataBottom.length == 0)
                                    this.formDataOriginal.reverse().forEach(section => {
                                        if(section[0].name == 'has_given_consent') {
                                            this.formDataBottom.push(section);
                                        } else {
                                            var check = false;
                                            section.forEach(item => {
                                                if(required_fields[item.name] && (required_fields[item.name].indexOf('required') > -1 || required_fields[item.name].indexOf('validschool') > -1))
                                                    check = true;
                                            })
                                            if(!check)
                                                this.formData.push(section);
                                            else
                                                this.formData.unshift(section);
                                        }
                                    })
                                this.required_fields = required_fields;
                            })
                }, 500),
            ageBasedTshirt : function() {
                var today = new Date();
                var age = today.getFullYear() - this.dob.year;
                var m = today.getMonth() - this.dob.month;
                if (m < 0 || (m === 0 && today.getDate() < this.dob.date)) {
                    age--;
                }
                if (age>14) {
                    this.required_fields['tshirt_size_id'] = [];
                    this.required_fields['tshirt_size_id'].push('required');
                }
            }
        },
        watch: {
            'participant': {
                handler: function (val, oldVal) {
                    this.getRequiredFields();
                },
                deep: true
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.participant;
            },
            name: function() {
                return {
                    full_name: (this.participant.first_name + " " + this.participant.last_name).capitalize(),
                    first: this.participant.first_name.capitalize(),
                    last: this.participant.last_name.capitalize()
                }
            },
            dateofbirth: function() {
                if(!this.dob.date || !this.dob.month || !this.dob.year)
                    return "";
                else
                    this.ageBasedTshirt();
                    return (new Date(this.dob.year,this.dob.month-1,this.dob.date)).toShortDateString();
            },
            formDataOriginal: function() {
                return [
                    [
                        {
                            name: 'first_name',
                            type: 'text',
                            prompt: this.$root.locale.participant.form.first_name.prompt,
                            placeholder: this.$root.locale.participant.form.first_name.label,
                            errormessage: this.$root.locale.participant.form.first_name.error,
                        },
                        {
                            name: 'last_name',
                            type: 'text',
                            prompt: this.$root.locale.participant.form.last_name.prompt,
                            placeholder: this.$root.locale.participant.form.last_name.label,
                            errormessage: this.$root.locale.participant.form.last_name.error,
                        },
                        {
                            name: 'dob',
                            type: 'date',
                            prompt: this.$root.locale.participant.form.dob.prompt,
                            placeholder: this.$root.locale.participant.form.dob.label,
                            errormessage: this.$root.locale.participant.form.dob.error
                        }
                    ],
                    [
                        {
                            name: 'gender_id',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.gender_id.prompt,
                            placeholder: this.$root.locale.participant.form.gender_id.label,
                            errormessage: this.$root.locale.participant.form.gender_id.error,
                            half: true
                        },
                        {
                            name: 'other_gender',
                            type: 'text',
                            prompt: this.$root.locale.participant.form.other_gender.prompt,
                            placeholder: this.$root.locale.participant.form.other_gender.label,
                            errormessage: this.$root.locale.participant.form.other_gender.error,
                            dependant: {
                                name: 'gender_id',
                                value: '3'
                            }
                        },
                    ],
                    
                    [
                        {
                            name: 'school_id',
                            type: 'select',
//                            prompt: this.$root.locale.participant.form.school_id.prompt,
                            placeholder: this.$root.locale.participant.form.school_id.label,
                            errormessage: this.$root.locale.participant.form.school_id.error,
                            half: true,
                        },
                        {
                            name: 'non_uk_school_name',
                            type: 'text-autocomplete',
//                            prompt: this.$root.locale.participant.form.non_uk_school_name.prompt,
                            placeholder: this.$root.locale.participant.form.non_uk_school_name.label,
                            errormessage: this.$root.locale.participant.form.non_uk_school_name.error,
                            pro_button: 'I cannot find the child\'s school',
                            pro_show: this.participant.non_uk_school_name != null && this.participant.non_uk_school_name != "",
                            options: this.school_datalist,
                        }
                    ],
                    [
                        {
                            name: 'doctor_details',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.doctor_details.prompt,
                            placeholder: this.$root.locale.participant.form.doctor_details.label,
                            errormessage: this.$root.locale.participant.form.doctor_details.error,
                        }
                    ],
                    [
                        {
                            name: 'emergency_contact',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.emergency_contact.prompt,
                            placeholder: this.$root.locale.participant.form.emergency_contact.label,
                            errormessage: this.$root.locale.participant.form.emergency_contact.error,
                        }
                    ],
                    [
                        {
                            name: 'has_treatment_permission',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.has_treatment_permission.prompt,
                            placeholder: this.$root.locale.participant.form.has_treatment_permission.label,
                            errormessage: this.$root.locale.participant.form.has_treatment_permission.error,
                            values: [
                                { value: 0, display: 'Cannot be treated' },
                                { value: 1, display: 'Can be treated' },
                                { value: 2, display: 'Can be treated with exceptions' },
                            ]
                        },
                        {
                            name: 'treatment_exceptions',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.treatment_exceptions.prompt,
                            placeholder: this.$root.locale.participant.form.treatment_exceptions.label,
                            errormessage: this.$root.locale.participant.form.treatment_exceptions.error,
                           dependant: {
                               name: 'has_treatment_permission',
                               value: 2
                           }
                        }
                    ],
                    [
                        {
                            name: 'has_swimming_session_permission',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.has_swimming_session_permission.prompt,
                            placeholder: this.$root.locale.participant.form.has_swimming_session_permission.label,
                            errormessage: this.$root.locale.participant.form.has_swimming_session_permission.error,
//                            description: this.$root.locale.participants.ParticipantNotEnoughDetails.HasSwimmingSessionPermission[0],
                            values: [
                                { value: 1, display: 'Yes' },
                                { value: 0, display: 'No' }
                            ],
                            half: true,
                        },
                        {
                            name: 'swimming_ability_id',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.swimming_ability_id.prompt,
                            placeholder: this.$root.locale.participant.form.swimming_ability_id.label,
                            errormessage: this.$root.locale.participant.form.swimming_ability_id.error,
                            half: true,
                            dependant: {
                                name: 'has_swimming_session_permission',
                                value: 1
                            }
                        }
                    ],
                    [
                        {
                            name: 'has_promotional_photography_permission',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.has_promotional_photography_permission.prompt,
                            placeholder: this.$root.locale.participant.form.has_promotional_photography_permission.label,
                            errormessage: this.$root.locale.participant.form.has_promotional_photography_permission.error,
//                            description: this.$root.locale.participants.ParticipantNotEnoughDetails.HasPromotionalPhotographPermission[0],
                            values: [
                                { value: 1, display: 'Yes' },
                                { value: 0, display: 'No' }
                            ],
                            half: true,
                        }
                    ],
                    [
                        {
                            name: 'has_return_home_unaccompanied_permission',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.has_return_home_unaccompanied_permission.prompt,
                            placeholder: this.$root.locale.participant.form.has_return_home_unaccompanied_permission.label,
                            errormessage: this.$root.locale.participant.form.has_return_home_unaccompanied_permission.error,
//                            description: this.$root.locale.participants.ParticipantNotEnoughDetails.HasReturnHomePermission[0],
                            values: [
                                { value: 1, display: 'Yes' },
                                { value: 0, display: 'No' }
                            ],
                            half: true,
                        }
                    ],
                    [
                        {
                            name: 'tshirt_size_id',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.tshirt_size_id.prompt,
                            placeholder: this.$root.locale.participant.form.tshirt_size_id.label,
                            errormessage: this.$root.locale.participant.form.tshirt_size_id.error,
                            half: true,
                        }

                    ],
                    [
                        {
                            name: 'parents_support_question',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.parents_support_question.prompt,
                            placeholder: this.$root.locale.participant.form.parents_support_question.label,
                            errormessage: this.$root.locale.participant.form.parents_support_question.error,
                            values: [
                                { value: 1, display: 'Yes' },
                                { value: 0, display: 'No'}
                            ]
                        },
                        {
                            name: 'parents_support_notes',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.parents_support_notes.prompt,
                            placeholder: this.$root.locale.participant.form.parents_support_notes.label,
                            errormessage: this.$root.locale.participant.form.parents_support_notes.error,
                            dependant: {
                                name: 'parents_support_question',
                                value: 1
                            }
                        }
                    ],
                    [
                        {
                            name: 'has_behaviour_issues',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.has_behaviour_issues.prompt,
                            placeholder: this.$root.locale.participant.form.has_behaviour_issues.label,
                            errormessage: this.$root.locale.participant.form.has_behaviour_issues.error,
                            values: [
                                { value: 1, display: 'Yes'},
                                { value: 0, display: 'No' }
                            ]
                        },
                        {
                            name: 'behaviour_issue_details',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.behaviour_issue_details.prompt,
                            placeholder: this.$root.locale.participant.form.behaviour_issue_details.label,
                            errormessage: this.$root.locale.participant.form.behaviour_issue_details.error,
                            dependant: {
                                name: 'has_behaviour_issues',
                                value: 1
                            }
                        }
                    ],
                    [
                        {
                            name: 'needs_assistance',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.needs_assistance.prompt,
                            placeholder: this.$root.locale.participant.form.needs_assistance.label,
                            errormessage: this.$root.locale.participant.form.needs_assistance.error,
                            values: [
                                { value: 1, display: 'Yes' },
                                { value: 0, display: 'No'}
                            ]
                        },
                        {
                            name: 'assistance_details',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.assistance_details.prompt,
                            placeholder: this.$root.locale.participant.form.assistance_details.label,
                            errormessage: this.$root.locale.participant.form.assistance_details.error,
                            dependant: {
                                name: 'needs_assistance',
                                value: 1
                            }
                        }
                    ],
                    [
                        {
                            name: 'has_medicial_issues',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.has_medicial_issues.prompt,
                            placeholder: this.$root.locale.participant.form.has_medicial_issues.label,
                            errormessage: this.$root.locale.participant.form.has_medicial_issues.error,
                            values: [
                                { value: 1, display: 'Yes' },
                                { value: 0, display: 'No'}
                            ]
                        },
                        {
                            name: 'medical_issue_details',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.medical_issue_details.prompt,
                            placeholder: this.$root.locale.participant.form.medical_issue_details.label,
                            errormessage: this.$root.locale.participant.form.medical_issue_details.error,
                            dependant: {
                                name: 'has_medicial_issues',
                                value: 1
                            }
                        }
                    ],
                    [
                        {
                            name: 'has_allergies',
                            type: 'radio',
                            prompt: this.$root.locale.participant.form.has_allergies.prompt,
                            placeholder: this.$root.locale.participant.form.has_allergies.label,
                            errormessage: this.$root.locale.participant.form.has_allergies.error,
                            values: [
                                { value: 2, display: 'Yes' },
                                { value: 1, display: 'Anaphylaxis' },
                                { value: 0, display: 'No'}
                            ]
                        },
                        {
                            name: 'allergy_details',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.allergy_details.prompt,
                            placeholder: this.$root.locale.participant.form.allergy_details.label,
                            errormessage: this.$root.locale.participant.form.allergy_details.error,
                            dependant: [
                                {
                                    name: 'has_allergies',
                                    value: 1
                                },
                                {
                                    name: 'has_allergies',
                                    value: 2
                                }
                            ]
                        },
                    ],
                    [
                        {
                            name: 'camp_notes',
                            type: 'textarea',
                            prompt: this.$root.locale.participant.form.camp_notes.prompt,
                            placeholder: this.$root.locale.participant.form.camp_notes.label,
                            errormessage: this.$root.locale.participant.form.camp_notes.error,
                        }
                    ],
                    [
                        {
                            name: 'has_given_consent',
                            type: 'checkbox',
                            prompt: this.$root.locale.participant.form.has_given_consent.prompt,
                            placeholder: this.$root.locale.participant.form.has_given_consent.label,
                            errormessage: this.$root.locale.participant.form.has_given_consent.error,
//                            description: this.$root.locale.participants.ParticipantNotEnoughDetails.GivenConsent[0],
                            values: [
                                { id: 1, display: 'I give consent' },
                            ]
                        },
                    ]
                ];
            }
        },
        created () {
            /**
             * Date of birth validation
             **/
            this.$validator.remove('dateofbirth');// Want to remove it incase it already exists.
            this.$validator.extend('dateofbirth', {
                getMessage: field => 'This must contain a valid child\'s date of birth.',
                validate: value => value.isValidDate() && (value.toDate()).getAge() < 18
            });

            //Getting the participant
            axios.get('/camp-booking/participants/'+(this.$route.params.hasOwnProperty('id') ? this.$route.params.id : this.participantId))
                .then(response => {
                    this.participant = response.data.data;

                    if(this.participant.has_given_consent === 1)
                        this.participant.has_given_consent = true;
                    else
                        this.participant.has_given_consent = false;
                    /** Setting has_treatment_permission to 2 if there is something in exceptions **/
                    if(this.participant.has_treatment_permission === 1 && this.participant.treatment_exceptions)
                        this.participant.has_treatment_permission = 2;

                    if(this.participant.has_return_home_unaccompanied_permission == 1 || this.participant.has_return_home_unaccompanied_permission === true)
                        this.participant.has_return_home_unaccompanied_permission = 1;
                    else
                        this.participant.has_return_home_unaccompanied_permission = 0;

                    var dobArray = this.participant.dob.split("-");
                    this.dob = {
                        date: dobArray[2],
                        month: Math.abs(dobArray[1]),
                        year: dobArray[0]
                    }

                    /** Updating the basket count **/
                    this.$root.updateBasketCount();

                    /**
                     * Setting the headers
                     **/
                    this.$root.headers = {
                        navigate: (this.$route.params.hasOwnProperty('id') ? { name: 'account.children' } : null),
                        title: this.$root.locale.miscellaneous.page_headings.cart.confirm_participant_details + ' ' + this.name.full_name,
                        show_venue: false,
                        allow_change: true,

                    }
                })


            //Getting all the required fields
            this.getRequiredFields();

            /**
             * Lookup data callsF
             */

            //Genders
            axios.get('/camp-booking/lookups/genders')
                .then(response => {
                    this.lookups.gender_id = response.data.data;
                })

            //Swimming Abilities
            axios.get('/camp-booking/lookups/swimming-abilities')
                .then(response => {
                    this.lookups.swimming_ability_id = response.data.data;
                })

            //T-shirt sizes
            axios.get('camp-booking/lookups/tshirt-sizes')
                .then(response => {
                    var tshirt_sizes = response.data.data;
                    this.lookups.tshirt_size_id = tshirt_sizes.slice(0, -1);
                })
        },
    }
</script>



// WEBPACK FOOTER //
// ParticipantComplete.vue?119d02f4